export const REDUCER_KEY = "albumsJazz";
export const SET_ALBUMS_FEATURED = "SET_ALBUMS_FEATURED";
export const SET_ALBUMS = "SET_ALBUMS";
export const SET_SEARCH_ALBUMS = "SET_SEARCH_ALBUMS";
export const SET_FILTERED_ALBUMS = "SET_FILTERED_ALBUMS";
export const SET_GENRES = "SET_GENRES";
export const CLEAR_ALBUMS = "CLEAR_ALBUMS";
export const SET_ALBUMS_DEFAULTS = "SET_ALBUMS_DEFAULTS";
